module.exports = __webpack_public_path__ + "img/cacao-1.50c264a6.png";